import fetchApi from "../fetchApi";
export const ResetPassword = async (email, password, token) => {
    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "email": email,
            "password": password,
            "token": token
        }),
        redirect: 'follow'
    }

    return await fetchApi(`auth/reset-password`, options, true);
};